document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.fb-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  const menuBtn = document.querySelector('[data-fb-menu]');
  const mobileNav = document.querySelector('[data-fb-mobile-nav]');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      menuBtn.classList.toggle('is-open', open);
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  const searchPanel = document.querySelector('[data-fb-search-panel]');
  const searchInput = document.querySelector('[data-fb-search-input]');
  const searchResults = document.querySelector('[data-fb-search-results]');
  const searchOpenTriggers = document.querySelectorAll('[data-fb-search-open]');
  const searchCloseTriggers = document.querySelectorAll('[data-fb-search-close]');

  if (searchPanel && searchInput && header) {
    let searchTimer = null;
    let searchAbort = null;

    const syncHeaderOffset = () => {
      header.style.setProperty('--fb-header-offset', `${header.offsetHeight}px`);
    };

    const escapeHtml = (value) =>
      String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    const renderSearchResults = (products) => {
      if (!searchResults) return;
      if (!products?.length) {
        searchResults.hidden = true;
        searchResults.innerHTML = '';
        return;
      }

      searchResults.hidden = false;
      searchResults.innerHTML = products
        .map((product) => {
          const image = product.featured_image?.url || product.image || '';
          const price = product.price ? `<span class="fb-header__search-result-price">${escapeHtml(product.price)}</span>` : '';
          const imageMarkup = image
            ? `<img src="${escapeHtml(image)}" alt="" width="48" height="48" loading="lazy">`
            : '';
          return `<a class="fb-header__search-result" href="${escapeHtml(product.url)}">${imageMarkup}<span class="fb-header__search-result-text"><span class="fb-header__search-result-title">${escapeHtml(product.title)}</span>${price}</span></a>`;
        })
        .join('');
    };

    const setSearchOpen = (open) => {
      syncHeaderOffset();
      searchPanel.classList.toggle('is-open', open);
      searchPanel.setAttribute('aria-hidden', open ? 'false' : 'true');
      header.classList.toggle('is-search-open', open);
      document.body.classList.toggle('fb-search-open', open);
      searchOpenTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', open ? 'true' : 'false'));

      if (open) {
        if (mobileNav?.classList.contains('is-open')) {
          mobileNav.classList.remove('is-open');
          menuBtn?.classList.remove('is-open');
          menuBtn?.setAttribute('aria-expanded', 'false');
        }
        window.setTimeout(() => searchInput.focus(), 80);
        return;
      }

      searchAbort?.abort();
      searchInput.value = '';
      renderSearchResults([]);
    };

    searchOpenTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        setSearchOpen(true);
      });
    });

    searchCloseTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => setSearchOpen(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && searchPanel.classList.contains('is-open')) {
        setSearchOpen(false);
      }
    });

    window.addEventListener('resize', syncHeaderOffset);

    searchInput.addEventListener('input', () => {
      const query = searchInput.value.trim();
      window.clearTimeout(searchTimer);

      if (query.length < 2) {
        searchAbort?.abort();
        renderSearchResults([]);
        return;
      }

      searchTimer = window.setTimeout(async () => {
        searchAbort?.abort();
        searchAbort = new AbortController();

        try {
          const params = new URLSearchParams({
            q: query,
            'resources[type]': 'product',
            'resources[limit]': '6',
            'resources[options][unavailable_products]': 'last',
          });
          const response = await fetch(`/search/suggest.json?${params.toString()}`, {
            signal: searchAbort.signal,
          });
          if (!response.ok) return;
          const data = await response.json();
          renderSearchResults(data.resources?.results?.products || []);
        } catch (error) {
          if (error?.name !== 'AbortError') return;
        }
      }, 280);
    });
  }

  document.querySelectorAll('[data-fb-tabs]').forEach((root) => {
    const tabs = root.querySelectorAll('[data-fb-tab]');
    const panels = root.querySelectorAll('[data-fb-panel]');
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => t.classList.remove('is-active'));
        panels.forEach((p) => p.classList.remove('is-active'));
        tab.classList.add('is-active');
        panels[i]?.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-fb-products]').forEach((root) => {
    const viewport = root.querySelector('[data-fb-products-viewport]');
    const track = root.querySelector('[data-fb-products-track]');
    const cards = track?.querySelectorAll('.fb-product-card');
    const fill = root.querySelector('[data-fb-products-progress-fill]');
    const progressTrack = root.querySelector('.fb-products-carousel__progress-track');
    const progressWrap = root.querySelector('[data-fb-products-progress]');
    const prevBtn = root.querySelector('[data-fb-products-prev]');
    const nextBtn = root.querySelector('[data-fb-products-next]');
    if (!viewport || !track || !cards?.length || !fill) return;

    const getVisible = () => {
      const styles = getComputedStyle(root);
      return parseInt(styles.getPropertyValue('--carousel-visible'), 10) || 1;
    };

    const getRows = () => {
      const styles = getComputedStyle(root);
      return parseInt(styles.getPropertyValue('--carousel-rows'), 10) || 1;
    };

    const getGap = () => parseFloat(getComputedStyle(track).gap) || 16;

    const getSnapCards = () => {
      const rows = getRows();
      if (rows <= 1) return [...cards];
      return [...cards].filter((_, index) => index % rows === 0);
    };

    const layoutSlides = () => {
      const gap = getGap();
      const visible = getVisible();
      const colWidth = (viewport.clientWidth - gap * (visible - 1)) / visible;
      root.style.setProperty('--carousel-col-width', `${Math.max(colWidth, 0)}px`);
      root.style.setProperty('--carousel-slide-width', `${Math.max(colWidth, 0)}px`);
      updateProgress();
    };

    const updateProgress = () => {
      const max = viewport.scrollWidth - viewport.clientWidth;
      if (progressWrap) progressWrap.hidden = max <= 1;
      const ratio = max > 0 ? viewport.scrollLeft / max : 0;
      fill.style.width = `${Math.max(ratio * 100, max > 0 ? 8 : 100)}%`;
      updateNav(max);
    };

    const updateNav = (maxScroll) => {
      const max = maxScroll ?? viewport.scrollWidth - viewport.clientWidth;
      const atStart = viewport.scrollLeft <= 1;
      const atEnd = viewport.scrollLeft >= max - 1;
      [prevBtn, nextBtn].forEach((btn) => {
        if (!btn) return;
        btn.hidden = max <= 1;
      });
      if (prevBtn) prevBtn.disabled = atStart;
      if (nextBtn) nextBtn.disabled = atEnd;
    };

    const scrollByPage = (direction) => {
      const snapCards = getSnapCards();
      if (!snapCards.length) return;
      const visible = getVisible();
      const current = viewport.scrollLeft;
      let currentIndex = 0;
      snapCards.forEach((card, index) => {
        if (card.offsetLeft <= current + 8) currentIndex = index;
      });
      let targetIndex = currentIndex + direction * visible;
      targetIndex = Math.max(0, Math.min(targetIndex, snapCards.length - 1));
      viewport.scrollTo({ left: snapCards[targetIndex].offsetLeft, behavior: 'smooth' });
    };

    const snapToNearest = () => {
      const snapCards = getSnapCards();
      let nearest = 0;
      let minDist = Infinity;
      snapCards.forEach((card) => {
        const offset = card.offsetLeft;
        const dist = Math.abs(viewport.scrollLeft - offset);
        if (dist < minDist) {
          minDist = dist;
          nearest = offset;
        }
      });
      viewport.scrollTo({ left: nearest, behavior: 'smooth' });
    };

    const drag = { active: false, moved: false, startX: 0, startScroll: 0, pointerId: null };
    let suppressClick = false;

    viewport.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', layoutSlides, { passive: true });

    progressTrack?.addEventListener('click', (event) => {
      const max = viewport.scrollWidth - viewport.clientWidth;
      if (max <= 0) return;
      const rect = progressTrack.getBoundingClientRect();
      const ratio = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
      viewport.scrollTo({ left: ratio * max, behavior: 'smooth' });
    });

    prevBtn?.addEventListener('click', () => scrollByPage(-1));
    nextBtn?.addEventListener('click', () => scrollByPage(1));

    viewport.addEventListener('pointerdown', (event) => {
      if (event.button !== 0) return;
      drag.active = true;
      drag.moved = false;
      drag.startX = event.clientX;
      drag.startScroll = viewport.scrollLeft;
      drag.pointerId = event.pointerId;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(event.pointerId);
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!drag.active || event.pointerId !== drag.pointerId) return;
      const delta = event.clientX - drag.startX;
      if (Math.abs(delta) > 4) drag.moved = true;
      if (drag.moved) event.preventDefault();
      viewport.scrollLeft = drag.startScroll - delta;
    });

    const endDrag = (event) => {
      if (!drag.active || (event.pointerId !== undefined && event.pointerId !== drag.pointerId)) return;
      drag.active = false;
      viewport.classList.remove('is-dragging');
      if (drag.pointerId !== null) {
        try { viewport.releasePointerCapture(drag.pointerId); } catch (e) { /* noop */ }
      }
      drag.pointerId = null;
      if (drag.moved) {
        suppressClick = true;
        snapToNearest();
        window.setTimeout(() => { suppressClick = false; }, 0);
      }
      drag.moved = false;
    };

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    viewport.addEventListener('click', (event) => {
      if (suppressClick) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);

    layoutSlides();
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-fb-card-add-btn], .fb-product-card__add--link')) {
      event.stopPropagation();
    }
  }, true);

  document.querySelectorAll('[data-fb-reviews]').forEach((root) => {
    const track = root.querySelector('[data-fb-reviews-track]');
    const dots = root.querySelectorAll('[data-fb-reviews-dot]');
    const slides = root.querySelectorAll('.fb-reviews__slide');
    const prev = root.querySelector('[data-fb-reviews-prev]');
    const next = root.querySelector('[data-fb-reviews-next]');
    if (!track || !dots.length) return;

    let index = 0;
    let timer;

    const go = (i) => {
      index = (i + dots.length) % dots.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((d, j) => d.classList.toggle('is-active', j === index));
      slides.forEach((s, j) => s.classList.toggle('is-active', j === index));
    };

    const resetTimer = () => {
      clearInterval(timer);
      timer = setInterval(() => go(index + 1), 7000);
    };

    dots.forEach((dot, i) => dot.addEventListener('click', () => { go(i); resetTimer(); }));
    prev?.addEventListener('click', () => { go(index - 1); resetTimer(); });
    next?.addEventListener('click', () => { go(index + 1); resetTimer(); });

    go(0);
    resetTimer();
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    document.querySelectorAll('[data-fb-reveal]').forEach((el) => observer.observe(el));
  } else {
    document.querySelectorAll('[data-fb-reveal]').forEach((el) => el.classList.add('is-visible'));
  }

  const announcement = document.querySelector('[data-fb-announcement]');
  if (announcement) {
    const slides = announcement.querySelectorAll('[data-fb-announcement-slide]');
    const autoplay = announcement.dataset.fbAnnouncementAutoplay === 'true';
    const speed = Number(announcement.dataset.fbAnnouncementSpeed || 5) * 1000;

    if (slides.length > 1 && autoplay) {
      let index = 0;
      window.setInterval(() => {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, speed);
    }
  }
});
